<template>
    <common-modal :showCloseIcon="true" width="huge" :heading="getTitle" @close="emitEvent({ name: 'close' })">
        <common-content-spacer height="huge">
            <div>{{ getDescription }}</div>
            <div class="category-info">
                <div>
                    <p v-if="!offer.hidePrice">
                        {{ categoryDiscountPrice }}
                        <span v-if="category.priceEUR > category.discountedPriceEUR" class="category-info--discount">
                            {{ categoryPrice }} {{ offer.currency === CurrencyEnum.EUR ? CurrencyEnum.EUR : CurrencyEnum.RSD }}
                        </span>
                    </p>
                    <p v-else class="category-info--hidden">
                        {{ offer.currency }}
                    </p>
                </div>
                <div>{{ getAppointmentLengthLabel(category.appointmentLength) }}</div>
            </div>
            <div class="category-description">
                {{ category.description }}
            </div>
            <div v-if="category?.linkedDiscounts?.length" class="category-discount">
                -{{ category.linkedDiscounts[0].discountPercentage * 100 }}%
            </div>
            <common-buttons>
                <common-button
                    type="secondary"
                    :isSubmittable="false"
                    :isProcessing="false"
                    :label="$t('common.microcopy.back')"
                    @click="emitEvent({ name: 'close' })"
                ></common-button>
            </common-buttons>
        </common-content-spacer>
    </common-modal>
</template>
<script>
    import AppointmentLengthEnum from 'enums/appointment_length.enum'
    import CurrencyEnum from 'enums/currency.enum'
    import PriceMixin from 'mixins/PriceMixin'
    import TranslateMixin from 'mixins/TranslateMixin'

    export default {
        mixins: [PriceMixin, TranslateMixin],
        props: {
            category: { type: Object, required: true },
            offer: { type: Object, required: true },
        },

        data() {
            return {
                CurrencyEnum: CurrencyEnum,
            }
        },

        computed: {
            getTitle() {
                return this.getTranslation(this.category?.titleTextContent)
            },

            getDescription() {
                return this.getTranslation(this.category?.descriptionTextContent)
            },

            categoryDiscountPrice() {
                let price = this.setPrice(this.category[`discountedPrice${this.offer.currency}`])

                return `${this.offer.currency} : ${price}`
            },
            categoryPrice() {
                let price = this.setPrice(this.category[`price${this.offer.currency}`])

                return `${this.offer.currency} : ${price}`
            },
        },
        methods: {
            getAppointmentLengthLabel(value) {
                return AppointmentLengthEnum[this.$i18n.locale].find((option) => option.value === value)?.label
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/mixins';

    .category-discount {
        position: absolute;
        top: -40px;
        right: 80px;
        font-weight: 400;
        background-color: $color-gold;
        border-radius: 10px;
        padding: 5px;
    }

    .category-info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        font-size: 20px;
        font-weight: 500;
        color: $color--accent-1;

        &--discount {
            text-decoration: line-through;
            opacity: 0.5;
            font-size: 12px;
            font-weight: 400;
            vertical-align: super;
            font-size: smaller;
        }
        &--hidden {
            @include hiddenBlur();
        }
    }

    .subdomain-layout {
        .category-info {
            color: $color-bright-red;
        }

        &--navy_black,
        &--black {
            .category-info {
                color: $subdomain-blue;
            }

            .category-description {
                color: $subdomain-light2;
            }
        }
    }
</style>
